import React from "react";
import { withRouter } from 'react-router-dom';
import AppChat from "../app-chat/app-chat";
import PropTypes from "prop-types";
import $ from "jquery";
import "./page-projects-single-inbox.css";
import { ServiceProjects } from "../../services/service-projects";
import _ from "lodash";
import appState from "../../state/AppStateContainer";
import { ServiceUser } from '../../services/service-user';
import AppLayout from "../../components/layout/app-layout/app-layout";
import BackButton from "../../components/shared/BackButton/BackButton";
import { withTranslation } from "react-i18next";

class PageProjectsSingleInbox extends React.Component {
  state = {
    baseURL: "",
    dataLoaded: false,
    clients: [],
    currentSupplier: {},
    currentClient: {},
    totalFilesClient: [],
    totalFilesUser: [],
    messages: [],
    currentProject: { area: [] },
    getConversation: {
      conversation: []
    },
    adminUser: {},
    loading: true,
  };
  key;
  appChat;

  // Props
  clients = [];
  currentSupplier = {};
  currentClient = {};
  totalFilesClient = [];
  totalFilesUser = [];
  messages = [];
  location;
  history;
  baseURL;

  async componentDidMount() {
    if ( !appState.state.token && (this.props.role || appState.getRoleFromUrlParams()) != "supplier") {
      this.props.history.push("/");
    }

    if (!_.isNull(this.props.currentProject)) {
      this.setState(
        {
          currentProject: this.props.currentProject,
          role: this.props.role || appState.getRoleFromUrlParams()
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({ clients: clients });
          await this.loadMessages();
        }
      );
    } else if (this.props.match.params.project) {
      const project = await this.getProjectBySlug(this.props.match.params.project);
      this.setState(
        {
          role: this.props.role || appState.getRoleFromUrlParams(),
          currentProject: project
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({ clients: clients });
          await this.loadMessages();
        }
      );
    }
    this.hasClickedSupplier = false;
  }

  fixOldBidFormLink = (msg, supMemberId) => {
    const oldLinkText = this.props.t('oldBidFormLinkText', 'Klicka här för att se inlämnat bud');
    if (msg.includes(oldLinkText)) {
      let parent = document.createElement('div');
      parent.innerHTML = msg;
      parent.querySelectorAll('a').forEach(aTag => {
        if(aTag?.href && !aTag.href.split(",")[1] && aTag.innerText === oldLinkText) {
          aTag.href = aTag.href+","+supMemberId;
        }
      });
      return parent.outerHTML;
    }
    return msg;
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    if (!appState.state.token && (nextProps.role || appState.getRoleFromUrlParams()) != "supplier") {
      this.props.history.push("/");
    }
    // window.location.reload()
    const newPathName = nextProps.location.pathname;
    if (!_.isEqual(this.props.currentProject, nextProps.currentProject) || this.props.location.pathname != newPathName) {
      this.setState({loading: true});
      const project = await this.getProjectBySlug(this.props.match.params.project);
      this.setState(
        {
          role: nextProps.role || appState.getRoleFromUrlParams(),
          currentProject: project
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({
            clients: clients
          });
          await this.loadMessages();
        }
      );
    }
  }

  async getProjectBySlug(slug) {
    if (appState.isSupplierRole()) {
      const supplier = await ServiceUser.getUserById(appState.state.token.id);
      return await ServiceProjects.getProjectBySlugForSupplier(
        slug,
        supplier.supplierId
      );
    }

    return await ServiceProjects.projectBySlug(slug)
  }

  getParams() {
    return this.props?.params ?? this.props?.match?.params;
  }

  getArea() {
    const { type } = this.getParams();
    let areaItem = [];
    const currentProject = this.state.currentProject;
    areaItem = currentProject.area.find(val => val.areaId && val.areaId.slug === type);
    this.setState({
      areaId: areaItem.areaId._id,
      areaName: areaItem.areaId.name,
    });
    return areaItem;
  }

  getSupplier() {
    const { supplier } = this.getParams();
    var area = this.getArea();
    var supplierItem = area.suppliers.filter(val => val.supplierId.slug == supplier);
    const currentSupplier = supplierItem[0] && supplierItem[0].supplierId;
    this.setState({ currentSupplier: currentSupplier });
    return currentSupplier;
  }

  async getClients() {
    var s = this.getSupplier();
    let clients = await ServiceProjects.getSupplierMembers(s._id, true);
    let clientsWithConversation = await ServiceProjects.getConversationMembers(
      this.state.currentProject._id,
      this.state.areaId,
      this.state.currentSupplier._id,
    );
    return clients
      .map(c => ({...c, hasConversation: !!clientsWithConversation.find(conv => conv._id == c._id)}))
      .filter(c => c.isActive || clientsWithConversation.find(conv => conv._id == c._id));
  }

  handleHistory() {
    this.clients = this.getClients();
    this.loadMessages();
  }

  async sortClients(clients) {
    clients = await this.getClients();
    var hasConversationArr = [];
    var restArr = [];
    clients.filter(val => {
      if (val.hasConversation) {
        hasConversationArr.push(val);
      } else {
        restArr.push(val);
      }
    });

    hasConversationArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    restArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    return [...hasConversationArr, ...restArr];
  }

  async loadMessages() {
    var locationURL = window.location.pathname;
    var client = locationURL;

    this.key = client;

    let clients = await this.sortClients();
    let currentClient = {};
    let basePath;
    if (this.props.supplierMemberId) {
      currentClient = clients.find(x => x._id === this.props.supplierMemberId);
    } else {
      if (this.props.match.params.supplierMember) {
        currentClient = clients.find(val => val.slug == this.props.match.params.supplierMember);
        let currentSupplierMenu = $(`[data-supplier-slug=${currentClient.slug}${this.state.areaId}]`);
        if (!this.hasClickedSupplier && currentSupplierMenu.length) {
          currentSupplierMenu[0].click();
          this.hasClickedSupplier = true;
        }
      } else {
        currentClient = { ...clients[0] };
        basePath = `${this.key}/${currentClient.slug}`;
        this.props.history.replace(basePath);
      }
    }

    const payload = {
      suppliermemberId: currentClient._id,
      projectId: this.state.currentProject._id,
      supplierId: this.state.currentSupplier._id,
      areaId: this.state.areaId
    };
    this.props.setCurrentData(payload);

    const getConversation = await ServiceProjects.getConversation(
      payload.supplierId,
      payload.projectId,
      payload.suppliermemberId,
      payload.areaId
    );


    let conversation = [];
    let totalFilesClient = [];
    let totalFilesUser = [];

    if (getConversation) {
      const isSupplierRole = appState.isSupplierRole();
      conversation = getConversation.conversation.map(x => {
        x.message = isSupplierRole ? this.fixOldBidFormLink(x.message, payload.suppliermemberId) : x.message;
        return ({
        _id: x._id,
        message: x.message,
        name: x.adminId ? x.adminId.name : x.supplierMemberId ? x.supplierMemberId.name : "",
        email: x.adminId ? x.adminId.email : x.supplierMemberId ? x.supplierMemberId.email : "",
        phone: x.adminId ? x.adminId.phone : x.supplierMemberId ? x.supplierMemberId.phone : "",
        type: x.adminId ? "user" : "client",
        date: x.createdAt,
        avatarUrl :x.adminId ? x.adminId.avatarUrl : "",
        files: x.attachment,
        isUnread: x.isUnread
      })
    });
      totalFilesClient = _.flatten(
        getConversation.conversation
          .filter(x => x.supplierMemberId)
          .map(x =>
            x.attachment.map(a => ({
              ...a,
              date: x.createdAt
            }))
          )
      );
      totalFilesUser = _.flatten(
        getConversation.conversation
          .filter(x => x.adminId)
          .map(x =>
            x.attachment.map(a => ({
              ...a,
              user: x.adminId,
              date: x.createdAt
            }))
          )
      );
    }

    this.setState({
      adminUser: getConversation ? getConversation.adminId : {},
      clients,
      currentClient,
      messages: conversation,
      totalFilesUser,
      totalFilesClient,
      baseURL: basePath,
      loading: false,
    });
  }

  getAllMemberNotifications = (supplierId) => {
    const { areaId } = this.state;
    const { currentProject } = this.props;
    let notification = [];

    const area = currentProject?.area?.find(ar => ar?.areaId?._id === areaId);

    if(area?.suppliers?.length) {
      const supplier = area.suppliers.find(s => s.supplierId._id === supplierId);
      const supNotifications = supplier?.supplierId?.notification;
      if (supNotifications) notification = supNotifications;
    }
    return notification;
  }

  getMemberNotification = (payload) => {
    const { supplierId, suppliermemberId } = payload;
    const allMemberNotifications = this.getAllMemberNotifications(supplierId);

    if (!suppliermemberId || !allMemberNotifications.length) return;

    const notification = allMemberNotifications.find(not => not.supplierMemberId === suppliermemberId);
    return notification;
  }

  goBack = () => {
    this.props.history.push(this.props.history.location.pathname.split('/').slice(0, 5).join('/'));
  }

  handleMarkUnread = async (messageId) => {
    try {
      await ServiceProjects.markMessageUnread({
        projectId: this.state.currentProject._id,
        supplierId: this.state.currentSupplier._id,
        supplierMemberId: this.state.currentClient._id,
        areaId: this.state.areaId,
        messageId
      });

      this.setState(prevState => ({
        messages: prevState.messages.map(msg => 
          msg._id === messageId ? { ...msg, isUnread: true } : msg
        )
      }));

      await appState.refreshProjectNotifications();
    } catch (error) {
      console.error('Failed to mark message as unread:', error);
    }
  }

  handleMarkRead = async (messageId) => {
    try {
      await ServiceProjects.markMessageRead({
        projectId: this.state.currentProject._id,
        supplierId: this.state.currentSupplier._id,
        supplierMemberId: this.state.currentClient._id,
        areaId: this.state.areaId,
        messageId
      });

      this.setState(prevState => {
        const updatedMessages = prevState.messages.map(msg => 
          msg._id === messageId ? { ...msg, isUnread: false } : msg
        );
        
        const hasUnreadMessages = updatedMessages.some(msg => msg.isUnread);
        
        if (!hasUnreadMessages && this.props.clearNotification) {
          const payload = {
            suppliermemberId: this.state.currentClient._id,
            supplierId: this.state.currentSupplier._id,
            areaId: this.state.areaId
          };
          const currentMemberNotification = this.getMemberNotification(payload);
          this.props.clearNotification(currentMemberNotification);
        }
        
        return { messages: updatedMessages };
      });

      await appState.refreshProjectNotifications();
    } catch (error) {
      console.error('Failed to mark message as read:', error);
    }
  }

  getNotificationsWithLocalCount = () => {
    const supplierId = this.state.currentSupplier?._id;
    const notifications = this.getAllMemberNotifications(supplierId) || [];
    const currentClientId = this.state.currentClient?._id;
    const { areaId } = this.state;
    
    if (!currentClientId) {
      return notifications;
    }

    const localUnreadCount = this.state.messages.filter(msg => msg.isUnread).length;

    const existingNotifIndex = notifications.findIndex(
      notif => notif.supplierMemberId === currentClientId
    );

    if (existingNotifIndex >= 0) {
      return notifications.map(notif => {
        if (notif.supplierMemberId === currentClientId) {
          return { ...notif, count: localUnreadCount };
        }
        return notif;
      });
    } else if (localUnreadCount > 0) {
      return [
        ...notifications,
        {
          supplierMemberId: currentClientId,
          areaId: areaId,
          count: localUnreadCount
        }
      ];
    }

    return notifications;
  }

  render() {
    const isBidForm = window.location.pathname.includes("/quotation/info");
    return (
      <AppLayout hideNavbar={isBidForm}
        title={
          <BackButton
            path={[this.state.currentProject?.name, this.state.areaName, this.state.currentSupplier?.name, this.props.t('button.back', 'Meddelanden')]}
            onClick={this.goBack}
          />}
      >
        <div className="page-projects-single-inbox">
          <AppChat
            adminUser={this.state.adminUser}
            role={this.state.role}
            areaId={this.state.areaId}
            ref={el => this.state.appChat}
            baseURL={this.state.baseURL}
            messages={this.state.messages}
            totalFilesClient={this.state.totalFilesClient}
            totalFilesUser={this.state.totalFilesUser}
            clients={this.state.clients}
            currentSupplier={this.state.currentSupplier}
            currentProjectId={this.state.currentProject._id}
            currentClient={this.state.currentClient}
            notification={this.getNotificationsWithLocalCount()}
            loading={this.state.loading}
            onMarkUnread={this.handleMarkUnread}
            onMarkRead={this.handleMarkRead}
          />
        </div>
      </AppLayout>
    );
  }
}

export default withRouter(withTranslation('projects', { keyPrefix: 'singleProject.inbox' })(PageProjectsSingleInbox));
